export interface SummaryReportGroup {
  field: string;
  key: string | null;
  totalDurationSecs: number;
  billableDurationSecs: number;
  entryCount: number;
  amountCents: number;
  subGroups: SummaryReportGroup[] | null;
}

export interface GetSummaryReportResult {
  totalDurationSecs: number;
  billableDurationSecs: number;
  amountCents: number;
  groups: SummaryReportGroup[];
}

export interface DetailedReportEntry {
  timeEntryId: string;
  userId: string;
  projectId?: string;
  clientId?: string;
  description?: string;
  isBillable: boolean;
  startedAt: string;
  endedAt?: string;
  durationSecs: number;
  tagIds: string[];
  amountCents: number;
}

export interface DetailedReportDay {
  date: string;
  dayTotalDurationSecs: number;
  entries: DetailedReportEntry[];
}

export interface GetDetailedReportResult {
  totalDurationSecs: number;
  billableDurationSecs: number;
  amountCents: number;
  days: DetailedReportDay[];
}

export interface WeeklyReportGroup {
  field: string;
  key: string | null;
  clientId?: string;
  totalDurationSecs: number;
  billableDurationSecs: number;
  entryCount: number;
  amountCents: number;
  dailyDurationSecs: Record<string, number>;
  subGroups: WeeklyReportGroup[] | null;
}

export interface GetWeeklyReportResult {
  weekStart: string;
  weekEnd: string;
  weekTotalDurationSecs: number;
  weekBillableDurationSecs: number;
  weekAmountCents: number;
  groups: WeeklyReportGroup[];
}

/** Backward-compat alias */
export type DailySummaryResult = SummaryReportGroup;

// ---------- Smart Report (AI work-log quality) ----------

/** Numeric enum mirroring backend WorkLogQualityCategory (serialized as int). */
export enum WorkLogQualityCategory {
  Good = 0,
  NeedsReview = 1,
  Bad = 2,
}

export interface QualityCounts {
  good: number;
  needsReview: number;
  bad: number;
  unscored: number;
  total: number;
}

export interface UserQualityBreakdown extends QualityCounts {
  userId: string;
  userName: string;
}

export interface SmartSummaryResult {
  from: string;
  to: string;
  elevated: boolean;
  totals: QualityCounts;
  perUser: UserQualityBreakdown[];
}

export interface SmartDetailItem {
  timeEntryId: string;
  userId: string;
  userName: string;
  projectId?: string;
  description?: string;
  startedAt: string;
  category: WorkLogQualityCategory | null;
  reason?: string;
}

export interface SmartDetailsResult {
  from: string;
  to: string;
  elevated: boolean;
  items: SmartDetailItem[];
}
